<template>
  <div class="_order_">
    <div class="my_order">
      退货退款
    </div>
    <div class="clearfix_ return_goods_list_notice">
      <div class="fl return_goods_list_notice_img"><img src="http://img.source.9188cn.com/return_goods_list_notice.png" alt=""></div>
      <div class="fl return_goods_list_notice_txt">温馨提示：参加满减优惠活动的订单，退货后剩余商品不满足满减优惠条件不满足时不参加；如果有赠品，赠品需要一并退回；使用优惠券的订单如产生退货，优惠券均不退回；退货金额以小计为准。</div>
    </div>
    <div class="order_state_item">
      <div class="order_state_item_tit clearfix_">
        <p class="name">商品</p>
        <p class="price">单价</p>
        <p class="num">数量</p>
        <p class="goodsOperation">商品操作</p>
        <!-- <p class="collectGoods">收货人</p> -->
        <p class="payMoney">退款总金额</p>
        <p class="state">订单状态</p>
        <p class="operation">操作</p>
      </div>
      <div class="order_state_item_goods clearfix_" v-for="(item,index) in returnGoodsList" :key="index">
        <div class="order_state_item_goods_h2 clearfix_">
          <p v-show="item.scode" class="fl">订单号：<span>{{item.scode}}</span></p>
          <p class="fl">单据时间：<span>{{item.orderDate}}</span></p>
        </div>
        <div class="clearfix_">
          <div class="fl" style="width:531px;">
            <div v-for="(val,idx) in item.goodsData" :key="idx" class="order_state_item_goods_content clearfix_">
              <img class="fl" :src="val.pic?val.pic:timg" alt="">
              <p @click="toGoods(val.dom,val.goodsId,val.supplyChainTenantId)" class="fl describe">{{val.goodsName}}<br>{{val.goodsUnitName}} {{val.property1}}</p>
              <p class="fl price">¥{{val.salesMoney}}</p>
              <p class="fl num">{{val.num}}</p>
              <p class="fl goodsOperation"></p>
            </div>
          </div>
          <div class="fl clearfix_" :style="{height:item.goodsData.length*120+'px'}">
            <p class="fl payMoney clearfix_">
              <span style="margin-top:10px;" class="fl">¥{{item.totalAmount}}</span>
            </p>
            <p class="fl state clearfix_">
              <span style="margin-top:10px;" class="fl">{{item.statusStr}}</span>
              <span style="cursor:pointer;margin-top:10px;" class="fl">
                <span @click="seeDetails(item.id,item.type)">查看详情</span>
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '../../assets/css/reset.css'
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
export default {
  data(){
    return {
      returnGoodsList:[],
      timg:require('../../assets/img/timg.gif'),
    }
  },
  mounted:function(){
    var t_=this
    t_.listMallReturn()
  },
  methods:{
    seeDetails:function(id,type){
      var t_=this
      var href=t_.$router.push({name: 'replacementGoods',query: {orderId:id,type:type}})
      // return window.open(href.href,'_blank')
    },
    listMallReturn:function(){
      var t_=this
      var data0bj={
        channel:2,
        tamp:localStorage.tamp?localStorage.tamp:'',
        id:t_.$route.query.orderId
      }
      data0bj=Qs.stringify(data0bj)
      axios.post(`${ip}formWorkInterface/listMallReturn`,data0bj).then(res =>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          t_.returnGoodsList=res.data.data
        }
      })
    },
    toGoods:function(web,id,supplyChainTenantId){
      var t_=this
      var url='http://'+web+'/goodsdetails?goodsId='+id + '&supplyChainTenantId=' + supplyChainTenantId + '&isSupplyChainGoods=2'
      window.open(url,'_blank')
    },
  }
}
</script>
<style>
  ._order_{
    background:#fff;
    padding: 25px 20px 0 20px;
    border: 1px solid #ddd;
  }
  .my_order{
    height: 34px;
    background: #eee;
    margin-bottom: 35px;
    border: 1px solid #e0e0e0;
    border-left: 5px solid #dd2c3a;
    line-height: 34px;
    font-size:16px;
    text-indent: 15px;
    color:#333;
    font-weight: 900;
  }
  .order_status{
    margin-bottom: 20px;
    border-bottom: 1px solid #cecece;
  }
  .order_status ul{
    height: 25px;
    width: 610px;
  }
  .order_status li span{
    padding: 0 19px;
    height: 25px;
    text-align: center;
    cursor: pointer;
  }
  .order_status li i{
    color:#ccc;
  }
  .order_status li{
    font-size:14px;
  }
  .order_status li:last-child i{
    display: none;
  }
  .order_status .order_status_active{
    color:#dd2c3a;
     border-bottom: 4px solid #dd2c3a;; 
    position: relative;
    z-index: 100;
    height: 22px;
  }
  .order_status li:last-child{
    border-right:0;
  }
  .order_status .order_search{
    /* border: 1px solid #e5e5e5; */
    margin-top: -6px;
    position: relative;
    height: 26px;
  }
  .order_status .order_search input{
    border:1px solid #ccc;
    width: 240px;
    height: 26px;
    padding-left: 5px;
  }
  .order_status .order_search span{
    width: 69px;
    height: 26px;
    position: absolute;
    background: #f5f5f5;
    top: 1px;
    right: 1px;
    text-align: center;
    line-height: 26px;
    cursor: pointer;
  }
  .order_state_item_tit{
    height: 30px;
    background: #f5f5f5;
    margin-bottom: 20px;
    /* padding-left: 308px; */
  }
  .order_state_item_tit .name{
    width: 308px;
    text-align: center;
  }
  .order_state_item_tit p{
    float: left;
    line-height: 30px;
  }
  .order_state_item_tit .price{
    width: 85px;
    text-align: center;
  }
  .order_state_item_tit .num{
    width: 55px;
    text-align: center;
  }
  .order_state_item_tit .goodsOperation{
    width: 86px;
    text-align: center;
  }
  .order_state_item_tit .collectGoods{
    width: 110px;
    text-align: center;
  }
  .order_state_item_tit .payMoney{
    width: 110px;
    text-align: center;
  }
  .order_state_item_tit .state{
    width: 110px;
    text-align: center;
  }
  .order_state_item_tit .operation{
    width: 120px;
    text-align: center;
  }
  .order_state_item_goods{
    border: 1px solid #e5e5e5;
    margin-bottom: 20px;
  }
  .order_state_item_goods_h2{
    background:#f5f5f5;
    border-bottom:1px solid #e5e5e5;
    height: 39px;
  }
  .order_state_item_goods_h2 p{
    line-height: 39px;
    color:#b4b4b4;
    padding-left: 20px;
  }
  .order_state_item_goods_h2 p span{
    color:#333;
  }
  .order_state_item_goods_content{
    padding-left: 10px;
    min-height: 120px;
    float: left;
  }
  .order_state_item_goods_content img{
    width: 80px;
    height: 80px;
    margin-right: 15px;
    margin-top: 20px;
  }
  .order_state_item_goods_content .describe{
    width: 180px;
    line-height: 20px;
    margin-right: 20px;
    margin-top: 20px;
    height: 100%;
    cursor: pointer;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
  }
  .order_state_item_goods_content .describe:hover{
    color:#dd2a3c;
  }
  .order_state_item_goods_content .price{
    width: 85px;
    text-align: center;
    margin-top: 20px;
    height: 100%;
  }
  .order_state_item_goods_content .num{
    width: 55px;
    text-align: center;
    margin-top: 20px;
    height: 100%;
  }
  .order_state_item_goods_content .goodsOperation{
    width: 85px;
    text-align: center;
    border-right: 1px solid #e5e5e5;
    min-height: 110px;
    padding-top: 10px;
  }
  .order_state_item_goods .collectGoods{
    width: 109px;
    text-align: center;
    border-right: 1px solid #e5e5e5;
    height: 100%;
  }
  .order_state_item_goods .collectGoods span{
    width: 100%;
    text-align: center;
  }
  .order_state_item_goods .payMoney{
    width: 109px;
    text-align: center;
    border-right: 1px solid #e5e5e5;
    height: 100%;
  }
  .order_state_item_goods .payMoney span{
    width: 100%;
    margin-bottom: 12px;
  }
  .order_state_item_goods .state{
    width: 109px;
    text-align: center;
    border-right: 1px solid #e5e5e5;
    height: 100%;
  }
  .order_state_item_goods .state span{
    width: 100%;
    /* margin-bottom: 12px; */
  }
  .order_state_item_goods .operation{
    text-align: center;
    height: 100%;
    width: 125px;
  }
  .order_state_item_goods .operation span{
    width: 100%;
    /* margin-bottom: 12px; */
     cursor: pointer;
  }
  .order_state_item_goods .operation span button{
     width:  72px;
     height: 24px;
     color:#fff;
     text-align: center;
     line-height: 24px;
     background: #dd2c3a;
     border: 0;
     border-radius: 2px;
     font-size: 12px;
     cursor: pointer;
  }
  .order_page{
    margin-bottom: 20px;
    text-align: center;
  }
  .order_page .el-pagination__jump{
    margin-top:-9px;
  }
  .order_page .el-pagination__jump .el-pagination__editor{
    top: 9px;
  }
  .noTime{
    text-align: center;
    margin-bottom: 20px;
  }
  .return_goods_list_notice{
    padding: 20px;
    background: #fafafa;
    margin-bottom: 25px;
    margin-top: -10px;
  }
  .return_goods_list_notice_img{
    width: 32px;
    height: 32px;
    margin-right: 20px;
  }
  .return_goods_list_notice_img img{
    width: 32px;
    height: 32px;
  }
  .return_goods_list_notice_txt{
    width: 895px;
    line-height: 16px;
  }
</style>


// WEBPACK FOOTER //
// src/components/member/viewReturns.vue